const getItemsHeights = ({ items, getItemHeights }) => items.map((...params) => getItemHeights(...params));
export {
  getItemsHeights
};
//# sourceMappingURL=getItemsHeights.js.map
